import Avatar from '@mui/material/Avatar';
import { cyan, deepOrange, grey, lime } from '@mui/material/colors';
import SituacaoIdDescricaoBase from './SituacaoIdDescricaoBase';

/**
 * Enum para tipos de remessas de julgamento de processos.
 *
 * @readonly
 * @constant
 * @enum {Object}
 */
// prettier-ignore
export const TIPO_REMESSA_JULGAMENTO_PROCESSO = {
    NR:  { id: 'NR',  nome: 'Não remetido',                           descricao: 'Não remetido',                                   codigo: 'NR',  abreviacao: 'NR',  cor: grey[800]       },
    RP:  { id: 'RP',  nome: 'Remetido para Sessão Presencial',        descricao: 'Remetido para sessão presencial vinculada',      codigo: 'RP',  abreviacao: 'RP',  cor: cyan[800]       },
    RF:  { id: 'RF',  nome: 'Remetido para Sessão Futura',            descricao: 'Remetido para sessão futura (não especificada)', codigo: 'RF',  abreviacao: 'RF',  cor: deepOrange[700] },
    RFV: { id: 'RFV', nome: 'Remetido para Sessão Futura Virtual',    descricao: 'Remetido para sessão futura virtual',            codigo: 'RFV', abreviacao: 'RFV', cor: lime[700]       },
    RFP: { id: 'RFP', nome: 'Remetido para Sessão Futura Presencial', descricao: 'Remetido para sessão futura presencial',         codigo: 'RFP', abreviacao: 'RFP', cor: cyan[800]       },
};

/**
 * @classdesc Facilita o acesso às propriedades e valores da enum de tipos de remessas de julgamento de processos.
 * @readonly
 */
export default class TipoRemessaJulgamentoProcesso {
    static idDescricaoBase = new SituacaoIdDescricaoBase(TIPO_REMESSA_JULGAMENTO_PROCESSO);
    static MSG_ERRO_IDENTIFICACAO_TIPO_REMESSA_JULGAMENTO_PROCESSO =
        'Não foi possível identificar o tipo de remessa de julgamento do processo.';

    static getDescricao(id) {
        return TipoRemessaJulgamentoProcesso.idDescricaoBase.getDescricao(id);
    }

    static getNome(id) {
        return TipoRemessaJulgamentoProcesso.idDescricaoBase.getValorPropriedade(id, 'nome');
    }

    static getCodigo(id) {
        return TipoRemessaJulgamentoProcesso.idDescricaoBase.getValorPropriedade(id, 'codigo');
    }

    static getCor(id) {
        return TipoRemessaJulgamentoProcesso.idDescricaoBase.getValorPropriedade(id, 'cor');
    }

    static getAbreviacao(id) {
        return TipoRemessaJulgamentoProcesso.idDescricaoBase.getValorPropriedade(id, 'abreviacao');
    }

    static getIcone(id) {
        const larguraIcone = '32px';
        const alturaIcone = '24px';
        const obj = TipoRemessaJulgamentoProcesso.idDescricaoBase.getObjectById(id);

        return (
            <Avatar
                variant="rounded"
                sx={{
                    width: larguraIcone,
                    height: alturaIcone,
                    fontWeight: '600',
                    fontSize: '0.96rem',
                    backgroundColor: obj?.cor ? obj.cor : TIPO_REMESSA_JULGAMENTO_PROCESSO.NR.cor
                }}
            >
                {obj?.abreviacao ? obj?.abreviacao : 'R'}
            </Avatar>
        );
    }

    static getItemByCodigo(codigo) {
        return TipoRemessaJulgamentoProcesso.idDescricaoBase.getObjectByProperty('codigo', codigo);
    }

    static getIdByCodigo(codigo) {
        const obj = TipoRemessaJulgamentoProcesso.getItemByCodigo(codigo);
        return obj ? obj.id : '';
    }

    static getDescricaoByCodigo(codigo) {
        return TipoRemessaJulgamentoProcesso.getDescricao(TipoRemessaJulgamentoProcesso.getIdByCodigo(codigo));
    }
}
